import { Link } from 'react-router-dom';
import '../styles/Services.css';
import { formations } from '../data/formations';

const iconsBySlug = {
  'wordpress': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <path d="M3 12h18" />
      <path d="M12 2a15.3 15.3 0 0 1 0 20 15.3 15.3 0 0 1 0-20z" />
    </svg>
  ),
  'seo': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  )
};

const services = formations.map((formation) => ({
  slug: formation.slug,
  title: formation.title,
  description: formation.shortDescription,
  icon: iconsBySlug[formation.slug]
}));



function Services() {
  return (
    <section className="services" id="formations">
      <div className="services-container">
        <div className="services-left">
          <span className="section-label">Nos formations</span>
          <h2 className="services-title">
            Découvrez nos formations<br />
          </h2>
          <p className="services-text">
            Découvrez et rejoignez nos formations pour débuter votre indépendance financière
          </p>
          <p className="services-text">
            <strong>Notre objectif :</strong> vous rendre autonome, avec une
            approche sérieuse, éthique et durable.
          </p>
        </div>
        <div className="services-cards">
          {services.map((service) => (
            <div className="service-card" key={service.slug}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <Link to={`/formations/${service.slug}`} className="btn btn-primary">Découvrir</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
